import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate,
  voidedServiceRequestItemFromPatientServiceRegister,
} from "app/services/ServiceRequestItemService";

export default class TreatmentTabStore {
  searchTreatment = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
    departmentId: null,
  };
  selectedServiceRequestItem = null;
  openConfirmDeleteNewServiceRequestItem = false;
  pageTreatment = new PageResponse();
  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatment = async () => {
    let { departmentId, healthCareSvId, ...ortherData } = this.searchTreatment;

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    return await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate({
      ...ortherData,
      getReport: true,
    })
      .then(({ data }) => {
        this.pageTreatment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điều trị có lỗi");
      });
  };

  setPageIndex = async (page) => {
      this.searchTreatment.pageIndex = page;
  
      await this.pagingTreatment();
    };
  
    setPageSize = async (value) => {
      this.searchTreatment.pageSize = value;
      this.searchTreatment.pageIndex = 1;
  
      await this.pagingTreatment();
    };
  
    handleChangePage = async (newPage) => {
      await this.setPageIndex(newPage);
    };

  handleChangeFormSearch = (searchTreatment) => {
    this.searchTreatment = { ...this.searchTreatment, ...searchTreatment };
    this.pagingTreatment();
  };

  handleDeleteNewServiceRequestItem = (item) => {
    this.selectedServiceRequestItem = {
      ...item,
    };

    this.openConfirmDeleteNewServiceRequestItem = true;
  };

  handleCloseConfirmDeleteNewServiceRequestItem = () => {
    this.openConfirmDeleteNewServiceRequestItem = false;
    this.selectedServiceRequestItem = null;
  };

  handleConfirmDeleteNewServiceRequestItem = async () => {
    if (!this.selectedServiceRequestItem?.id) {
      toast.error("Không có chỉ định dịch vụ nào được chọn để xóa.");
      return;
    }

    try {
      await voidedServiceRequestItemFromPatientServiceRegister(
        this.selectedServiceRequestItem?.id
      );
      toast.success("Xóa chỉ định dịch vụ thành công.");

      this.handleCloseConfirmDeleteNewServiceRequestItem();

      await this.pagingTreatment();
    } catch (error) {
      console.error(error);
      let message = "Xóa chỉ định dịch vụ thất bại.";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (typeof error?.response?.data === "string" && error.response.data) {
        message = error.response.data;
      } else if (error?.message) {
        message = error.message;
      }
      toast.error(message);
    }
  };

  resetStore = () => {
    this.pageTreatment = new PageResponse();

    this.searchTreatment = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
    };
  };
}
